import React from 'react';
import ChevronLeftRoundedIcon from '@mui/icons-material/ChevronLeftRounded';
import ChevronRightRoundedIcon from '@mui/icons-material/ChevronRightRounded';

function BookmarkTabs({ 
  setSessionsDrawerOpen, 
  setPatternsDrawerOpen,
  sessionsDrawerOpen,
  patternsDrawerOpen
}) {
  
  const handleTabClick = (tab) => {
    if (tab === 'sessions') {
      setSessionsDrawerOpen(prev => !prev);
    } else if (tab === 'patterns') {
      setPatternsDrawerOpen(prev => !prev);
    }
  };

  return (
    <div className="bookmark-system">
      <div className="bookmark-tabs" role="tablist" aria-label="Panel toggles">
        <button
          className={`bookmark-tab bookmark-tab-icon ${sessionsDrawerOpen ? 'active' : ''}`}
          onClick={() => handleTabClick('sessions')}
          role="tab"
          aria-selected={sessionsDrawerOpen}
          aria-label={sessionsDrawerOpen ? 'Collapse sessions panel' : 'Expand sessions panel'}
          title={sessionsDrawerOpen ? 'Collapse sessions panel' : 'Expand sessions panel'}
        >
          <ChevronLeftRoundedIcon fontSize="small" aria-hidden="true" focusable="false" />
          <span className="sr-only">Sessions panel</span>
        </button>
        <button
          className={`bookmark-tab bookmark-tab-icon ${patternsDrawerOpen ? 'active' : ''}`}
          onClick={() => handleTabClick('patterns')}
          role="tab"
          aria-selected={patternsDrawerOpen}
          aria-label={patternsDrawerOpen ? 'Collapse redaction patterns panel' : 'Expand redaction patterns panel'}
          title={patternsDrawerOpen ? 'Collapse redaction patterns panel' : 'Expand redaction patterns panel'}
        >
          <ChevronRightRoundedIcon fontSize="small" aria-hidden="true" focusable="false" />
          <span className="sr-only">Redaction patterns panel</span>
        </button>
      </div>
    </div>
  );
}

export default BookmarkTabs; 
